import React from 'react';

import { Box, Tag, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { addAccountUrl } from '../../Shared/addAccountUrl';

type Props = {
  name: string;
  description: string;
  imageUrl: string;
  id?: string;
  legacyProductCategory: string;
};

export const ProductOnboardingCrossSellItemEnvelopesEnabled: React.FC<Props> = ({
  id,
  name,
  description,
  legacyProductCategory,
  imageUrl,
}) => (
  <Box
    className={`group ${css({
      flex: 1,
      display: 'flex',
      backgroundColor: 'background.neutral',
    })}`}
  >
    <SambaAutoLink
      to={addAccountUrl({ product_category: legacyProductCategory })}
      title={name}
      css={{
        flex: 1,
        padding: 'space.200',
        textDecoration: 'none!important',
      }}
      onClick={() => trackClick({ name: `explore_more_products_${name.toLowerCase().replace(/\s/g, '_')}` })}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 'space.150' }}>
          <img src={imageUrl} alt={`${name} icon`} className={css({ width: '36px', height: '36px' })} />
          {id === 'direct_trading' && <Tag accent="teal">New</Tag>}
        </Box>
        <Box css={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Text css={{ color: 'text', _groupHover: { textDecoration: 'underline' } }}>{name}</Text>
          <Text css={{ textStyle: { base: 'text25', sm: 'text50' } }} color="text.weak">
            {description}
          </Text>
        </Box>
      </Box>
    </SambaAutoLink>
  </Box>
);

export const ProductOnboardingCrossSellItem: React.FC<Props> = ({
  name,
  description,
  legacyProductCategory,
  imageUrl,
}) => (
  <Box
    className={`group ${css({
      flex: 1,
      display: 'flex',
      borderWidth: 'thin',
      borderStyle: 'solid',
      borderColor: 'border',
      borderRadius: 'medium',
      _hover: {
        color: 'inherit',
        backgroundColor: 'inherit',
      },
    })}`}
  >
    <SambaAutoLink
      to={addAccountUrl({ product_category: legacyProductCategory })}
      title={name}
      css={{
        flex: 1,
        padding: 'space.200',
        textDecoration: 'none!important',
      }}
      onClick={() => trackClick({ name: `explore_more_products_${name.toLowerCase().replace(/\s/g, '_')}` })}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box css={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Text css={{ color: 'text', _groupHover: { textDecoration: 'underline' } }}>{name}</Text>
          <Text css={{ textStyle: { base: 'text25', sm: 'text50' } }} color="text.weak">
            {description}
          </Text>
        </Box>
        <img
          src={imageUrl}
          alt={`${name} icon`}
          className={css({ width: '36px', height: '36px', marginTop: 'space.400' })}
        />
      </Box>
    </SambaAutoLink>
  </Box>
);
